module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Schnellsuche: Vor- / Nachname, Login oder E-Mail","new":"Neuen Benutzer anlegen","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen"},"en":{"placeholder":"Fast search: first- / lastname, login or e-mail","new":"Create new user","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen"}}')
  delete Component.options._Ctor
}
